
<div class="sidebar-container flex flex-col">
  <Filters v-if="renderFilters()" :products="products" />
  <RequestQuote />
  <Links :organization="organization" :solutions="solutions" />
</div>
